"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneStructDef = exports.cloneSopDef = exports.cloneStructCtorDef = exports.cloneSopCtorDef = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
function cloneSopCtorDef(ctorDef) {
    var clone = {};
    for (var fieldName in ctorDef) {
        clone[fieldName] = ctorDef[fieldName];
    }
    return clone;
}
exports.cloneSopCtorDef = cloneSopCtorDef;
exports.cloneStructCtorDef = cloneSopCtorDef;
function cloneSopDef(def) {
    var clone = {};
    var ctors = Object.keys(def);
    for (var i = 0; i < ctors.length; i++) {
        (0, obj_utils_1.defineReadOnlyProperty)(clone, ctors[i], cloneSopCtorDef(def[ctors[i]]));
    }
    return clone;
}
exports.cloneSopDef = cloneSopDef;
exports.cloneStructDef = cloneSopDef;
